import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { API } from "./apiutil";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class ChannelService {
    http;
    constructor(http) {
        this.http = http;
    }
    getChannels(ctx) {
        return this.http.get(`${environment.base}/channel`, { params: API.makeParams(ctx) });
    }
    getChannelMessages(channelId, ctx) {
        return this.http.get(`${environment.base}/channel/${channelId}/messages`, { params: API.makeParams(ctx) });
    }
    getMessage(messageId) {
        return this.http.get(`${environment.base}/channel/message/${messageId}`);
    }
    static ɵfac = function ChannelService_Factory(t) { return new (t || ChannelService)(i0.ɵɵinject(i1.HttpClient)); };
    static ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ChannelService, factory: ChannelService.ɵfac });
}
